import React from 'react'
import { AppRoute } from 'src/navigation/appRoutes'
import { cancelSubscriptionRouteProps } from 'src/navigation/routeProps'
import CancelSubscriptionPage from 'src/page-components/CancelSubscriptionPage/CancelSubscriptionpage'

const CancelSubscriptionAppRoute: AppRoute = {
  routeProps: cancelSubscriptionRouteProps,
  component: <CancelSubscriptionPage />,
  subRoutes: [],
}

export default CancelSubscriptionAppRoute
